import './style.scss';
import {Router} from "./router.js";
import {MenuComponent} from "./components/shared/menu/menu.component.js";
import {FeedbackComponent} from "./components/shared/feedback/feedback.component.js";
import {CookieBannerComponent} from "./components/shared/cookie-banner/cookie-banner.component.js";
import {config} from "./config.js";
import {setInfoToLinks} from "./utils/setInfoToLinks.js";





class App {

    emailLinkElements = document.querySelectorAll("[data-email-link]");
    telegramChashkinLinkElements = document.querySelectorAll('[data-telegram-chashkin-link]');
    consistLinks = document.querySelectorAll("[data-link-consist]");

    constructor() {
        this.setConfigInfo();
        new Router();
        MenuComponent.init();
        FeedbackComponent.init();
        CookieBannerComponent.init();
    }

    setConfigInfo() {

        // ссылки на email
        setInfoToLinks(this.emailLinkElements, config.emailHref, config.email);

        // ссылки на телеграмм chashkin
        setInfoToLinks(this.telegramChashkinLinkElements, config.telegramChashkin);

        //ссылки на соглашение
        setInfoToLinks(this.consistLinks, config.consist);

    }

}(new App());